// import {
//   CircularProgress,
//   Drawer,
//   IconButton,
//   Paper,
//   Typography
// } from '@material-ui/core'
// import {
//   ArrowLeftRight,
//   Bot,
//   Clock,
//   UserRound,
//   Workflow,
//   X
// } from 'lucide-react'

// import Timeline from '@material-ui/lab/Timeline'
// import TimelineConnector from '@material-ui/lab/TimelineConnector'
// import TimelineContent from '@material-ui/lab/TimelineContent'
// import TimelineDot from '@material-ui/lab/TimelineDot'
// import TimelineItem from '@material-ui/lab/TimelineItem'
// import TimelineSeparator from '@material-ui/lab/TimelineSeparator'
// import useTicketHistory from '../../hooks/useTicketHistory'
// import { useStyles } from './style'

// const TicketInfoDrawer = ({
//   contact,
//   ticket,
//   loading,
//   open,
//   handleDrawerClose
// }) => {
//   const classes = useStyles()
//   const { history: ticketEvents, loading: timelineLoading } = useTicketHistory(
//     ticket,
//     contact
//   )

//   let processedEvents = []

//   const botEvents = ticketEvents.filter(event => event.note.includes('[Bot]'))
//   const otherEvents = ticketEvents.filter(
//     event =>
//       !event.note.includes('[Bot]') &&
//       !event.note.includes('🟢 Atendimento criado através do BOT pelo contato')
//   )

//   // Não cria a nota resumida do bot quando o atendimento é criado sem atendente
//   // if (botEvents.length > 0) {
//   //   const oldestBotEvent = botEvents.sort(
//   //     (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
//   //   )[0]

//   //   // 2. Crie o novo evento resumido
//   //   const botSummaryEvent = {
//   //     id: 'bot-summary', // ID único
//   //     note: '🟢 Atendimento criado pelo [Bot]',
//   //     type: 'history',
//   //     createdAt: oldestBotEvent.createdAt,
//   //     user: null
//   //   }
//   //   processedEvents.push(botSummaryEvent)
//   // }
//   processedEvents = [...processedEvents, ...otherEvents]
//   processedEvents.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))

//   const getEventDotInfo = (note, type) => {
//     let icon = <Workflow size={20} className={classes.historyDot}/>
//     let dotClass = classes.manualDot
//     if (type === 'history') {
//       if (note.includes('[Bot]')) {
//         icon = <Bot size={20} />
//         dotClass = classes.botDot
//       } else if (note.includes('🟢')) {
//         icon = <UserRound size={20} />
//         dotClass = classes.historyDot
//       } else if (note.includes('🔄')) {
//         icon = <ArrowLeftRight size={20} />
//         dotClass = classes.transferDot
//       } else if (note.includes('🔴')) {
//         icon = <X size={20} />
//         dotClass = classes.closedDot
//       } else if (note.includes('🟡')) {
//         icon = <Clock size={20} />
//         dotClass = classes.noteDot
//       }
//     }

//     return { icon, dotClass }
//   }

//   const getEventIcon = (note, type) => {
//     if (type === 'history') {
//       if (note.includes('[Bot]')) return <Bot size={20} />
//       if (note.includes('🟢')) return <UserRound size={20} />
//       if (note.includes('🔄')) return <ArrowLeftRight size={20} />
//       if (note.includes('🔴')) return <X size={20} />
//       if (note.includes('🟡')) return <Clock size={20} />
//     }
//     return <Workflow size={20} className={classes.historyDot}/>
//   }

//   const formatEventTitle = (note, type) => {
//     if (type === 'history') {
//       return note
//         .replace(/^(🟢|🔄|🔴|🟡|ℹ️)\s*/, '')
//         .replace(/\s*-\s*\d{2}\/\d{2}\/\d{4}.*$/, '')
//     }
//     return note
//   }

//   const getEventTime = createdAt => {
//     return new Date(createdAt).toLocaleTimeString([], {
//       hour: '2-digit',
//       minute: '2-digit'
//     })
//   }

//   return (
//     <Drawer
//       className={classes.drawer}
//       variant="persistent"
//       anchor="right"
//       open={open}
//       PaperProps={{
//         style: { position: 'absolute' }
//       }}
//       BackdropProps={{ style: { position: 'absolute' } }}
//       ModalProps={{
//         container: document.getElementById('drawer-container'),
//         style: { position: 'absolute' }
//       }}
//       classes={{
//         paper: classes.drawerPaper
//       }}
//     >
//       <div className={classes.container}>
//         {loading ? (
//           <CircularProgress />
//         ) : (
//           <>
//             <Paper component="div" elevation={0} className={classes.header}>
//               <div className={classes.timelineTitle}>
//                 Histórico do Atendimento
//               </div>
//               <div className={classes.closeButton}>
//                 <IconButton onClick={handleDrawerClose}>
//                   <X size={18} />
//                 </IconButton>
//               </div>
//             </Paper>
//             <div className={classes.scrollableContent}>
//               <Timeline className={classes.timeline}>
//                 {timelineLoading ? (
//                   <CircularProgress size={24} />
//                 ) : (
//                   processedEvents.map((event, index) => {
//                     const { icon, dotClass } = getEventDotInfo(
//                       event.note,
//                       event.type
//                     )

//                     return (
//                       <TimelineItem
//                         key={event.id}
//                         className={`${classes.timelineItem} ${dotClass}`}
//                       >
//                         <TimelineSeparator>
//                           <TimelineDot>
//                             {getEventIcon(event.note, event.type)}
//                           </TimelineDot>
//                           {index < processedEvents.length - 1 && (
//                             <TimelineConnector />
//                           )}
//                         </TimelineSeparator>
//                         <TimelineContent className={classes.timelineContent}>
//                           <Paper
//                             elevation={0}
//                             className={classes.timelinePaper}
//                           >
//                             <Typography
//                               variant="body2"
//                               color="textSecondary"
//                               className={classes.timelineContentDate}
//                             >
//                               <Clock size={14} />
//                               {getEventTime(event.createdAt)}
//                               <Typography
//                                   variant="caption"
//                                   color="textSecondary"
//                                   className={classes.timelineContentUser}
//                                 >
//                                   {event.user?.name || '[Bot]'}
//                                 </Typography>
//                             </Typography>
//                             <Typography
//                               variant="h6"
//                               component="h1"
//                               className={classes.timelineContentTitle}
//                             >
//                               {formatEventTitle(event.note, event.type)}
//                             </Typography>
//                           </Paper>
//                         </TimelineContent>
//                       </TimelineItem>
//                     )
//                   })
//                 )}
//               </Timeline>
//             </div>
//           </>
//         )}
//       </div>
//     </Drawer>
//   )
// }

// export default TicketInfoDrawer

import {
  CircularProgress,
  Paper,
  Typography
} from '@material-ui/core'
import {
  ArrowLeftRight,
  Clock,
  UserRound,
  Workflow,
  X
} from 'lucide-react'

import Timeline from '@material-ui/lab/Timeline'
import TimelineConnector from '@material-ui/lab/TimelineConnector'
import TimelineContent from '@material-ui/lab/TimelineContent'
import TimelineDot from '@material-ui/lab/TimelineDot'
import TimelineItem from '@material-ui/lab/TimelineItem'
import TimelineSeparator from '@material-ui/lab/TimelineSeparator'
import useTicketHistory from '../../hooks/useTicketHistory'
import { useStyles } from './style'

const TicketInfoTimeline = ({ contact, ticket }) => {
  const classes = useStyles()
  const { history: ticketEvents, loading: timelineLoading } = useTicketHistory(
    ticket,
    contact
  )

  // Filtra e ordena os eventos
  const processedEvents = ticketEvents
    .filter(event => 
      !event.note.includes('[Bot]') && 
      !event.note.includes('🟢 Atendimento criado através do BOT pelo contato')
    )
    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))

  const getEventIcon = (note, type) => {
    if (type === 'history') {
      if (note.includes('🟢')) return <UserRound size={20} />
      if (note.includes('🔄')) return <ArrowLeftRight size={20} />
      if (note.includes('🔴')) return <X size={20} />
      if (note.includes('🟡')) return <Clock size={20} />
    }
    return <Workflow size={20} className={classes.historyDot} />
  }

  const formatEventTitle = (note, type) => {
    if (type === 'history') {
      return note
        .replace(/^(🟢|🔄|🔴|🟡|ℹ️)\s*/, '')
        .replace(/\s*-\s*\d{2}\/\d{2}\/\d{4}.*$/, '')
    }
    return note
  }

  const getEventTime = createdAt => {
    return new Date(createdAt).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  if (timelineLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
        <CircularProgress size={24} />
      </div>
    )
  }

  return (
    <div className={classes.container}>
      <Timeline className={classes.timeline}>
        {processedEvents.map((event, index) => (
          <TimelineItem
            key={event.id}
            className={classes.timelineItem}
          >
            <TimelineSeparator>
              <TimelineDot className={classes.manualDot}>
                {getEventIcon(event.note, event.type)}
              </TimelineDot>
              {index < processedEvents.length - 1 && (
                <TimelineConnector />
              )}
            </TimelineSeparator>
            <TimelineContent className={classes.timelineContent}>
              <Paper
                elevation={0}
                className={classes.timelinePaper}
                style={{ backgroundColor: 'transparent' }}
              >
                <Typography
                  variant="body2"
                  color="textSecondary"
                  className={classes.timelineContentDate}
                  style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
                >
                  <Clock size={14} />
                  {getEventTime(event.createdAt)}
                  <span className={classes.timelineContentUser}>
                    • {event.user?.name || '[Bot]'}
                  </span>
                </Typography>
                <Typography
                  variant="h6"
                  component="h1"
                  className={classes.timelineContentTitle}
                  style={{ fontSize: '0.9rem', fontWeight: 500 }}
                >
                  {formatEventTitle(event.note, event.type)}
                </Typography>
              </Paper>
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </div>
  )
}

export default TicketInfoTimeline
